export interface TutorialInfo {
  id: string
  title: string
  description?: string
  load: () => Promise<string>
}

const gettingStartedContent = import('./getting-started.md?raw')
const howToSynthesizeHouseTrackContent = import('./how-to-synthesize-a-house-loop.md?raw')

export const tutorials: TutorialInfo[] = [
  {
    id: 'getting-started',
    title: 'Getting Started',
    description: 'Learn the basics of creating sounds and music with loopmaster',
    load: async () => {
      const module = await gettingStartedContent
      return module.default
    },
  },
  {
    id: 'how-to-synthesize-a-house-loop',
    title: 'How to Synthesize a House Loop',
    description: 'Build a house loop step by step, learning how to synthesize kick, hihats, snare, bass, and chords',
    load: async () => {
      const module = await howToSynthesizeHouseTrackContent
      return module.default
    },
  },
]

export async function loadTutorial(id: string): Promise<string> {
  const tutorial = tutorials.find(t => t.id === id)
  if (!tutorial) {
    throw new Error(`Tutorial not found: ${id}`)
  }

  try {
    return await tutorial.load()
  }
  catch (error) {
    console.error(`Error loading tutorial ${id}:`, error)
    throw error
  }
}

export function getTutorial(id: string): TutorialInfo | undefined {
  return tutorials.find(t => t.id === id)
}

export function getAllTutorials(): TutorialInfo[] {
  return tutorials
}
